export default "__VITE_ASSET__69c5beb6__"